import { useQuery } from "@tanstack/react-query";

import { fetchProducts } from "@/api/products";
import { ProductsResponse } from "@/types/api/products";
import { TServerError } from "@/types/api/shared";
import { convertToObjectById } from "@/utils/byId";
import { convertToObjectBySku } from "@/utils/bySku";

export const PRODUCTS_QUERY_KEY = "products";

interface CompleteProducts {
  products: ProductsResponse["products"];
  productsById: {
    [id: number]: ProductsResponse["products"][number];
  };
  productsBySku: {
    [skuCode: string]: ProductsResponse["products"][number];
  };
}

async function getCompleteProducts(category, country = "NO") {
  const { products } = await fetchProducts(category, country);

  return {
    products,
    productsBySku: convertToObjectBySku(products),
    productsById: convertToObjectById(products),
  } as CompleteProducts;
}

export function useProducts(category = "", country = "NO") {
  return useQuery<CompleteProducts, TServerError>([PRODUCTS_QUERY_KEY], () =>
    getCompleteProducts(category, country)
  );
}
